/* src/app/pages/logged-out/logged-out.page.scss */
ion-content.logged-out-content {
  --padding-top: env(safe-area-inset-top);
  --padding-bottom: env(safe-area-inset-bottom);
}
.background-image {
  background: url("./media/splash.jpg") no-repeat;
  background-position: center;
  background-size: cover;
  box-sizing: border-box;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: calc(var(--app-page-margin) * 1.5);
  padding-top: max(var(--app-page-margin) * 1.5, env(safe-area-inset-top, 0px));
  padding-bottom: max(var(--app-page-margin) * 3, env(safe-area-inset-bottom, 0px));
}
.background-image.buttons-expanded {
  padding-left: var(--app-page-margin);
  padding-right: var(--app-page-margin);
}
.background-image.buttons-expanded section,
.background-image.buttons-expanded .custom-select {
  max-width: 100%;
}
.logo {
  background: url("./media/logo.svg") no-repeat;
  width: 130px;
  height: 90px;
  background-size: contain;
  background-position: center;
  margin-top: auto;
}
h1 {
  color: var(--ion-color-primary-contrast);
  margin-top: 0;
  margin-bottom: 0.5em;
  text-align: center;
}
h2 {
  color: white;
  font-size: larger;
  margin-top: 0.75em;
  margin-bottom: 0.5em;
}
section {
  margin-top: 1em;
  width: 100%;
  max-width: 280px;
  opacity: 0;
  transition: opacity 500ms;
  pointer-events: none;
}
section.visible {
  opacity: 1;
  pointer-events: unset;
}
section.disabled {
  opacity: 0.5;
  pointer-events: none;
  transition: opacity 0s;
}
section ion-button {
  width: 100%;
  margin-bottom: 0.75em;
  font-size: unset;
  margin-inline: unset;
  height: auto;
  --height: auto;
  --padding-top: 0.65em;
  --padding-bottom: 0.65em;
}
section ion-button::part(native) {
  height: auto;
  min-height: 48px;
  white-space: normal;
  line-height: 1.25;
  text-align: center;
}
section #google-sign-in {
  flex-grow: 0;
  min-height: 48px;
  color-scheme: light;
}
section .spacer {
  margin-top: 0.25em;
  margin-bottom: 1em;
  width: 50%;
  height: 1px;
  background: gray;
}
.button-label {
  display: inline-block;
  max-width: 100%;
  white-space: normal;
  text-align: center;
  line-height: 1.25;
  overflow-wrap: break-word;
  text-wrap: balance;
}
ion-button[fill=outline] {
  --background: white;
}
.custom-select {
  margin-top: 0.5em;
  padding: 0;
  max-width: 280px;
  width: 100%;
}
.custom-select select {
  text-align: center;
  text-align-last: center;
}
.error {
  margin-bottom: 0;
  color: white;
}
label {
  color: white;
  margin-top: 0.75em;
}
.version {
  color: gray;
  margin-bottom: auto;
}
select {
  height: 2.7em;
}
/*# sourceMappingURL=logged-out.page.css.map */
